import React from "react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import { persistedStore, store } from "./store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { google } from "./config";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "reduxjs-toolkit-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate loading={null} persistor={persistedStore}>
        <GoogleOAuthProvider clientId={google.CLIENT_ID}>
          <App />
          <ToastContainer />
        </GoogleOAuthProvider>
      </PersistGate>
    </BrowserRouter>
  </Provider>
);

serviceWorker.unregister();
